import { render, staticRenderFns } from "./SOVDetailedOEM.vue?vue&type=template&id=dc3c5cf6&scoped=true"
import script from "./SOVDetailedOEM.vue?vue&type=script&lang=js"
export * from "./SOVDetailedOEM.vue?vue&type=script&lang=js"
import style0 from "./SOVDetailedOEM.vue?vue&type=style&index=0&id=dc3c5cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3c5cf6",
  null
  
)

export default component.exports